import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Button, message } from 'antd';
import { FileExcelOutlined } from '@ant-design/icons';
import moment from 'moment';
import { apiGetVotingResults } from '../../../../utils/api';
import { useEffect, useState } from 'react';

export const ExportReportsCurps = ({ period }) => {
    const [voters, setVoters] = useState([])
    const [loading, setloading] = useState(false)

    const getVotingResults = () => {
        if(!period) return
        setloading(true)
        apiGetVotingResults(period).then(res => {
            setVoters(res.data)
            exportToExcel()
        }).catch(err => {
            new Error(err)
        }).finally(() => {
            setloading(false)
        })
    }

    const exportToExcel = () => {
        if (!voters || voters.length === 0) {
            message.warning('No hay información para exportar.');
            return;
        }

        const simplifiedData = voters.map((v) => ({
            CURP: v.curp,
            Nombre: v.name,
            Proyecto: v.projectName
        }));

        const worksheet = XLSX.utils.json_to_sheet(simplifiedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Votantes');

        // Ajuste automático del ancho de las columnas
        const colWidths = Object.keys(simplifiedData[0]).map((key) => {
            const maxLength = Math.max(
                key.length,
                ...simplifiedData.map((item) => item[key]?.toString().length || 0)
            );
            return { wch: maxLength + 5 };
        });
        worksheet['!cols'] = colWidths;

        const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([wbout], { type: 'application/octet-stream' });
        saveAs(blob, `Votantes_PP_${moment().format('DD_MM_YYYY')}.xlsx`);
    };

    return (
        <Button
            icon={<FileExcelOutlined />}
            style={{ marginTop: 18, marginLeft: 170 }}
            type="link"
            onClick={getVotingResults}
        >
            Exportar votantes
        </Button>
    );
};
